import React, {ReactElement} from 'react';
import {Button, ButtonProps, makeStyles} from '@material-ui/core';
import {APP_PRIMARY_COLOR} from 'src/style/variable';
import './ButtonStyle.scss';

const styles = makeStyles(() => ({
  tertiaryButton: {
    background: 'rgba(40, 132, 255, 0.1)',
    borderRadius: '8px',
    color: APP_PRIMARY_COLOR,
    '&.MuiButton-sizeSmall .MuiButton-startIcon': {
      marginRight: '4px'
    },
    '&.MuiButtonBase-root': {
      fontSize: '1rem'
    }
  }
}));

const TertiaryButton = ({className, ...rest}: ButtonProps): ReactElement => {
  const classes = styles();
  return (
    <Button
      {...rest}
      className={`${classes.tertiaryButton} button-base ${className}`}
    />
  );
};

export default TertiaryButton;
